import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.dom-collections.iterator";
/* global Weglot */

/**
 * Component: Store selector
 * ------------------------------------------------------------------------------
 * A loosely coupled script to emit store data based on a store dropdown.
 * - Used in conjunction with the store-selector.liquid snippet.
 *
 * @namespace weglotSelector
 */

import { on, updateWeglotSelectorOption } from '~/helpers/utils';
/**
 * DOM selectors.
 */

const selectors = {
  weglotSelector: '[js-weglot-language-selector="selector"]',
  languageSelector: '[js-redirect-modal="languageSelector"]'
};
/**
 * Export a new store selector instance.
 */

export default (() => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    weglotSelector: [...document.querySelectorAll(selectors.weglotSelector)] || null
  };
  /**
   * Initialise component.
   */

  function init() {
    setEventListeners();
    setTimeout(() => {
      updateWeglotSelectorOption(nodeSelectors.weglotSelector);
    }, 2000);
  }
  /**
   * Set click events on toggle selectors.
   */


  function setEventListeners() {
    if (nodeSelectors.weglotSelector.length > 0) {
      nodeSelectors.weglotSelector.forEach(element => {
        on('change', element, event => handleLanguageChange(event));
      });
    }
  }
  /**
   * Update redirect modal default language selected based on current language
   *
   */


  function updateRedirectDefaultLanguageOption() {
    const languageSelector = document.querySelector(selectors.languageSelector);
    const currentLanguage = Weglot.getCurrentLang();
    const optionKeys = Object.keys(languageSelector.options);

    if (!languageSelector.options) {
      return;
    }

    optionKeys.forEach((key, index) => {
      if (languageSelector[key].value !== currentLanguage) {
        return;
      }

      languageSelector.options.selectedIndex = index;
    });
  }
  /**
   * Update the site language
   * @param {Object} event - language event.
   */


  function handleLanguageChange(event) {
    const selectedIndex = event.target.selectedIndex;
    const selectedLanguage = event.target[selectedIndex].getAttribute('value');
    Weglot.switchTo(selectedLanguage);
    updateWeglotSelectorOption(nodeSelectors.weglotSelector);
    updateRedirectDefaultLanguageOption();
  }
  /**
   * Expose public interface
   */


  return Object.freeze({
    init
  });
});